import angular from 'angular';
import Listing from '../listing';
import Browser from 'cars-ng-browser';
import Tracking from 'cars-ng-tracking';
import LeadForm from '../leadForm';

import component from './similarVehicles.component';
import service from './similarVehicles.service';

export default angular.module('vdp.similarVehicles', [
    Browser,
    'cars.ui.angular',
    Listing,
    LeadForm,
    Tracking,
])
.directive('carsSimilarVehicles', component)
.service('similarVehicles', service)

.name;
